import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import featureFlags from '../../../../common/helpers/featureFlags';

import {
  fetchDivestitureDiagnosticResults,
  getDivestitureDiagnosticResults,
  getFetchDivestitureDiagnosticResultsStatus,
} from '../../../divestitureDiagnostic/divestitureDiagnosticSlice';
import EnableForProjectState from '../../../security/EnableForProjectState';
import ShowForPermissions from '../../../security/ShowForPermissions';
import { projectType } from '../../common/projectOptions';
import WelcomeBoxBeginQuestionnaire from '../WelcomeBox/WelcomeBoxBeginQuestionnaire/WelcomeBoxBeginQuestionnaire';
import WelcomeBoxDealComplexity from '../WelcomeBox/WelcomeBoxDealComplexity/WelcomeBoxDealComplexity';
import WelcomeBoxQuickStart from '../WelcomeBox/WelcomeBoxQuickStart/WelcomeBoxQuickStart';

import './DiagnosticContainer.scss';

const DiagnosticContainer = ({ id, type, showDiagnostic }) => {
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const diagnosticData = useSelector(getDivestitureDiagnosticResults);

  const isBuySideProject = projectType.buy.id === type;
  const isSellSideProject = projectType.sell.id === type;
  const shouldShowDiagnostic = showDiagnostic && featureFlags.diagnostic;

  const { success: fetchResultsSuccess } = useSelector(
    getFetchDivestitureDiagnosticResultsStatus
  );

  useEffect(() => {
    let isMounted = true;
    if (!diagnosticData && isMounted) {
      dispatch(fetchDivestitureDiagnosticResults(id));
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch, diagnosticData, id]);

  return (
    <EnableForProjectState projectId={projectId}>
      {({ isProjectDisabled }) => (
        <div>
          <ShowForPermissions projectId={id} permissions={['Contribute']}>
            {isBuySideProject && !diagnosticData && !isProjectDisabled && (
              <WelcomeBoxQuickStart />
            )}
            {isSellSideProject &&
              (!shouldShowDiagnostic || diagnosticData) &&
              !isProjectDisabled && <WelcomeBoxQuickStart />}
          </ShowForPermissions>
          {shouldShowDiagnostic && fetchResultsSuccess && (
            <>
              {isSellSideProject && !diagnosticData && (
                <WelcomeBoxBeginQuestionnaire projectId={id} />
              )}
              {isSellSideProject &&
                diagnosticData &&
                diagnosticData.overallDealComplexity && (
                  <WelcomeBoxDealComplexity projectId={id} />
                )}
            </>
          )}
        </div>
      )}
    </EnableForProjectState>
  );
};

export default React.memo(
  DiagnosticContainer,
  (prev, next) =>
    prev.id === next.id &&
    prev.type === next.type &&
    prev.showDiagnostic === next.showDiagnostic
);
